import React, {Suspense, lazy} from 'react';
import { Row, Col, FormGroup,Button } from 'react-bootstrap';
import { MyContext } from '../../InitialSetup/MyProvider';
import { Helmet } from "react-helmet";
import CustomHeader from '../../components/CustomHeader';
import MetaData from "../../helper/MetaData";
import * as AppLabels from "../../helper/AppLabels";
import Images from '../../components/images';
import { Utilities } from '../../Utilities/Utilities';
import * as WSC from "../../WSHelper/WSConstants";
import { SELECTED_GAMET, GameType, PAYMENT_TYPE } from "../../helper/Constants";
import { depositPaytmFund, depositPayUmoneyFund, depositGocashFund, joinContest, depositIPAYFund, depositPayPalFund, depositPayStackFund, depositRazorPayFund, joinContestWithMultiTeam, callBuyCoins, getCashFreeGatewayList, joinContestNetworkfantasy, joinContestWithMultiTeamNF } from '../../WSHelper/WSCallings';
import WSManager from '../../WSHelper/WSManager';
import { createBrowserHistory } from 'history';
import Thankyou from '../../Modals/Thankyou';
import EditStateAndCityModal from '../../Modals/EditStateAndCityModal';
import CustomLoader from '../../helper/CustomLoader';
import * as Constants from "../../helper/Constants";
import ls from 'local-storage';
const ReactHTMLParser = lazy(()=>import('../CustomComponent/ReactHTMLParser'));
const ReactSelectDD = lazy(()=>import('../CustomComponent/ReactSelectDD'));
const queryString = require('query-string');

var hostName = window.location.host;
var fUrl = window.location.protocol + '//' + hostName + "/payment-method?status=failure"
var sUrl = window.location.protocol + '//' + hostName + "/payment-method?status=success"
var pUrl = window.location.protocol + '//' + hostName + "/payment-method?status=pending"
const history = createBrowserHistory();
const location = history.location;
const parsed = queryString.parse(location.search);

export default class PaymentMethod extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            amount: this.props.location.state ? this.props.location.state.amount : '',
            selectedDeal: this.props.location.state ? this.props.location.state.selectedDeal : "",
            PageContent: '',
            showThankYouModal: false,
            isLoading: false,
            mPromoCode: this.props.location.state ? this.props.location.state.promoCode : '',
            showStateTagModal: false,
            isCMounted: false,
            walletList: [],
            netBankingList: [],
            upiList: [{
                "payment_option": "upi",
                "upiMode": "gpay"
            },
            {
                "payment_option": "upi",
                "upiMode": "qrcode"

            }],
            paymentTypeSelected: '',
            checkIfCashfreeExist:false,
            selectedWallet: '',
            walletDropDownList: [],
            selectedWalletOption: '',

            selectedNetBanking: '',
            netBankingDropDownList: [],
            selectedNBoption: '',

            selectedUPI: '',
            upiDropDownList: [],
            selectedUPIoption: '',

            cardNumber: '',
            nameOnCard: '',
            expiryDate: '',
            cvvNumber: '',
            RFContestId: ''
        }
    }

    UNSAFE_componentWillMount() {
        this.checkTransactionFlow()

    }

    checkTransactionFlow = () => {
            let tempIsAddFundsClicked = WSManager.getFromFundsOnly();
            let contestData = WSManager.getContestFromAddFundsAndJoin()
            let FromConfirmPopupAddFunds = WSManager.getFromConfirmPopupAddFunds();
            let calledFrom = WSManager.getPaymentCalledFrom();
            let contestCoinData = WSManager.getContestFromAddCoinAndJoin();
            setTimeout(() => {
                if (tempIsAddFundsClicked != 'true' && (!this.props.location.state || !this.props.location.state.amount)) {
                    window.location.assign('/my-wallet')
                }
                else {
                    if (tempIsAddFundsClicked == 'true') {
                        if (parsed.status == "success") {
                            Utilities.showToast(AppLabels.Your_payment_successful, 1500);
                        } else if (parsed.status == "failure") {
                            Utilities.showToast(AppLabels.Your_payment_failed, 1500);
                        } else if (parsed.status == "pending") {
                            Utilities.showToast(AppLabels.Your_payment_pending, 1500);
                        }
                        WSManager.setFromFundsOnly(false);
                        this.callOnlyAfterTransactions(contestData, FromConfirmPopupAddFunds, calledFrom, contestCoinData)
                    }
                }
            }, 500);
         }

    callBuyCoinsApi(contestData, id) {
        let param = {
            "package_id": id
        }
        callBuyCoins(param).then((responseJson) => {
            if (responseJson.response_code == WSC.successCode) {
                Utilities.showToast('You have successfully Buy Coins', 2000);
            }
            else {
                Utilities.showToast(responseJson.global_error != "" ? responseJson.global_error : responseJson.message, 2000);
            }
            if (contestData != '') {
                this.CallJoinGameApi(contestData)
            }
            else {
                let mHist = parseInt(ls.get('back_history') || 0);
                let newHistory = this.props.history.length;
                let updatedHistory = (newHistory - mHist) + 3;
                this.props.history.go(-updatedHistory)
            }
        })
    }

    goToBuyCoinsScreen() {
        let mHist = parseInt(ls.get('back_history') || 0);
        let newHistory = this.props.history.length;
        let updatedHistory = (newHistory - mHist) + 2;
        this.props.history.go(-updatedHistory)
    }


    componentDidMount = () => {
        if(Constants.SELECTED_GAMET == Constants.GameType.DFS && Constants.RFContestId != ''){
            ls.set('RFContestID', Constants.RFContestId)
            this.setState({
                RFContestId:Constants.RFContestId
            })
        }
        this.handelNativePayu();
        this.checkIfCashfreeExist();
        this.setState({
            isCMounted: true
        })
        if (process.env.REACT_APP_STATE_TAGGING_ENABLE > 0 && (!WSManager.getProfile().master_state_id || !WSManager.getProfile().city)) {
            this.setState({
                showStateTagModal: true
            })
        }
    }
    handelNativePayu() {
        window.addEventListener('message', (e) => {
            if (e.data.action == 'payu' && e.data.type == 'Success') {
                parsed['status'] = 'success'
                this.checkTransactionFlow()
            }
            else if (e.data.action == 'payu' && e.data.type == 'Failed') {
                parsed['status'] = 'failure'
                if (parsed.status == "failure") {
                    Utilities.showToast(AppLabels.Your_payment_failed, 1500);
                }
            }

        });
    }

    onPaymentMethodSelect(method, type) {
        this.setState({ paymentTypeSelected: '' })
        switch (method) {
            case 'payumoney':
                this.PayumoneyDeposit();
                break;
            case 'paytm':
                this.PayTmDeposit();
                break;
            case 'gocash':
                if (type == PAYMENT_TYPE.CREDIT_DEBIT_CARD) {
                    this.handelPaymentType(type)
                    this.GoCashDeposit(type);
                }
                break;
            case 'ipay':
                this.iPayDeposit();
                break;
            case 'paypal':
                this.PayPalDeposit();
                break;
            case 'paystack':
                this.PayStackDeposit();
                break;
            case 'razorpay':
                this.RazorPayDeposit();
                break;
            case 'cashfree':
                if (type == PAYMENT_TYPE.CREDIT_DEBIT_CARD) {
                    this.handelPaymentType(type)
                    this.GoCashDeposit(type);
                }
                break;
            default:
                this.PayumoneyDeposit();
                break;
        }
        WSManager.setFromFundsOnly(true);
        WSManager.setIsFromPayment(true);

    }
    handelPaymentType = (type) => {
        this.setState({ paymentTypeSelected: type })

        if (type == PAYMENT_TYPE.WALLET) {
            this.setState({ selectedNetBanking: '', selectedNBoption: '', selectedUPIoption: '', selectedUPI: '', cardNumber: '', nameOnCard: '', expiryDate: '', cvvNumber: '' })
        }
        else if (type == PAYMENT_TYPE.NET_BANKING) {
            this.setState({ selectedWallet: '', selectedWalletOption: '', selectedUPIoption: '', selectedUPI: '', cardNumber: '', nameOnCard: '', expiryDate: '', cvvNumber: '' })

        }
        else if (type == PAYMENT_TYPE.UPI) {
            this.setState({ selectedWallet: '', selectedWalletOption: '', selectedNetBanking: '', selectedNBoption: '', cardNumber: '', nameOnCard: '', expiryDate: '', cvvNumber: '' })

        }
        else if (type == PAYMENT_TYPE.CREDIT_DEBIT_CARD) {
            this.setState({ selectedWallet: '', selectedWalletOption: '', selectedNetBanking: '', selectedNBoption: '', selectedUPIoption: '', selectedUPI: '' })

        }

    }

    onMethodSelected(method) {
        if (method == 'cashfree') {
            return true;
        }
        else {
            return false;
        }

    }

    PayTmDeposit = () => {
        let param = {
            "amount": this.state.amount,
            "furl": fUrl+`&amount=${this.state.amount}`,
            "surl": sUrl+`&amount=${this.state.amount}`,
            "promo_code": this.state.mPromoCode,
            "deal_id": this.state.selectedDeal ? this.state.selectedDeal.deal_id : ""
        }
        this.setState({ isLoading: true })
        ls.set('back_history', this.props.history.length)
        depositPaytmFund(param).then((responseJson) => {
            if (responseJson.response_code == WSC.successCode) {
                this.setState({
                    PageContent: responseJson.data
                })
                var paytmForm = document.forms.paytmForm;
                paytmForm.submit();
            }
            setTimeout(() => {
                this.setState({ isLoading: false })
            }, 500);
        })
    }

    PayStackDeposit = () => {
        let param = {
            "amount": this.state.amount,
            "furl": fUrl+`&amount=${this.state.amount}`,
            "surl": sUrl+`&amount=${this.state.amount}`,
            "promo_code": this.state.mPromoCode,
            "deal_id": this.state.selectedDeal ? this.state.selectedDeal.deal_id : ""
        }
        this.setState({ isLoading: true })
        ls.set('back_history', this.props.history.length)
        depositPayStackFund(param).then((responseJson) => {
            if (responseJson.response_code == WSC.successCode) {
                this.setState({
                    PageContent: responseJson.data
                })
                var paystackForm = document.forms.paystackform;
                paystackForm.submit();
            }
            this.setState({ posting: false, isLoading: false })
        })
    }

    PayPalDeposit = () => {
        let param = {
            "amount": this.state.amount,
            "furl": fUrl+`&amount=${this.state.amount}`,
            "surl": sUrl+`&amount=${this.state.amount}`,
            "promo_code": this.state.mPromoCode,
            "deal_id": this.state.selectedDeal ? this.state.selectedDeal.deal_id : ""
        }
        this.setState({ isLoading: true })
        ls.set('back_history', this.props.history.length)
        depositPayPalFund(param).then((responseJson) => {
            if (responseJson.response_code == WSC.successCode) {
                window.location.href = responseJson.data.payment_link;
            }
            setTimeout(() => {
                this.setState({ isLoading: false })
            }, 500);
        })
    }


    iPayDeposit = () => {
        let param = {
            "amount": this.state.amount,
            "furl": fUrl+`&amount=${this.state.amount}`,
            "surl": sUrl+`&amount=${this.state.amount}`,
            "promo_code": this.state.mPromoCode,
            "deal_id": this.state.selectedDeal ? this.state.selectedDeal.deal_id : ""
        }
        this.setState({ isLoading: true })
        ls.set('back_history', this.props.history.length)
        depositIPAYFund(param).then((responseJson) => {
            if (responseJson.response_code == WSC.successCode) {
                this.setState({
                    PageContent: responseJson.data
                })
                var ipayform = document.forms.ipayform;
                ipayform.submit();
            }
            setTimeout(() => {
                this.setState({ isLoading: false })
            }, 500);
        })
    }

    GoCashDeposit = (type) => {
        WSManager.setFromFundsOnly(true);
        WSManager.setIsFromPayment(true);
        let param = {
            "amount": this.state.amount,
            "furl": fUrl+`&amount=${this.state.amount}`,
            "surl": sUrl+`&amount=${this.state.amount}`,
            "purl": pUrl+`&amount=${this.state.amount}`,
            "promo_code": this.state.mPromoCode,
            "deal_id": this.state.selectedDeal ? this.state.selectedDeal.deal_id : ""
        }
        if (type == PAYMENT_TYPE.UPI) {
            if (this.state.selectedUPI != '') {
                param['paymentOption'] = PAYMENT_TYPE.UPI
                param['upiMode'] = this.state.selectedUPI.upiMode
            }
            else {
                Utilities.showToast("Please select at least one paymenet option", 1500);
                return;
            }

        }
        else if (type == PAYMENT_TYPE.CREDIT_DEBIT_CARD) {
            param['paymentOption'] = 'cashfree'
        }
        else if (type == PAYMENT_TYPE.WALLET) {
            if (this.state.selectedWallet != '') {
                if (this.state.selectedWallet.payment_code == '4007' && process.env.REACT_APP_CASHFREE_WALLET_PAYTM_ENABLE == 0) {
                    param['paymentOption'] = 'cashfree'
                }
                else {
                    param['paymentCode'] = this.state.selectedWallet.payment_code;
                    param['paymentOption'] = PAYMENT_TYPE.WALLET
                }
            }
            else {
                Utilities.showToast("Please select at least one paymenet option", 1500);
                return;
            }
        }
        else if (type == PAYMENT_TYPE.NET_BANKING) {
            if (this.state.selectedNetBanking != '') {
                param['paymentCode'] = this.state.selectedNetBanking.payment_code;
                param['paymentOption'] = 'nb'
            }
            else {
                Utilities.showToast("Please select at least one paymenet option", 1500);
                return;
            }
        }
        this.setState({ isLoading: true })
        ls.set('back_history', this.props.history.length)
        depositGocashFund(param).then((responseJson) => {
            if (responseJson.response_code == WSC.successCode) {
                this.setState({
                    PageContent: responseJson.data
                })
                var gocash = document.forms.gocashform;
                gocash.submit();
            }
            setTimeout(() => {
                this.setState({ isLoading: false })
            }, 500);
        })
    }


    cardValidation =()=> {
        if(this.state.cardNumber != '' &&  this.state.nameOnCard != '' && this.state.expiryDate !='' && this.state.cvvNumber != ''){
            return true;
        }
        else{
            return false;

        }
    }

    PayumoneyDeposit = () => {
        let param = {
            "amount": this.state.amount,
            "furl": fUrl+`&amount=${this.state.amount}`,
            "surl": sUrl+`&amount=${this.state.amount}`,
            "purl": pUrl+`&amount=${this.state.amount}`,
            "promo_code": this.state.mPromoCode,
            "deal_id": this.state.selectedDeal ? this.state.selectedDeal.deal_id : "",
            "is_mobile": window.ReactNativeWebView ? process.env.REACT_APP_PAYU_BIZ_ACCOUNT == 1 ? '0':'1' : '0'

        }
        this.setState({ isLoading: true })
        ls.set('back_history', this.props.history.length)
        depositPayUmoneyFund(param).then((responseJson) => {
            if (responseJson.response_code == WSC.successCode) {
                if (window.ReactNativeWebView && process.env.REACT_APP_PAYU_BIZ_ACCOUNT != 1) {
                    let payuData = {
                        action: 'payu',
                        targetFunc: 'payu',
                        data: responseJson.data,
                    }
                    window.ReactNativeWebView.postMessage(JSON.stringify(payuData));
                }
                else {
                    this.setState({
                        PageContent: responseJson.data
                    })
                    var payuForm = document.forms.payuForm;
                    payuForm.submit();
                }

            }
            setTimeout(() => {
                this.setState({ isLoading: false })
            }, 500);
        })
    }

    RazorPayDeposit = () => {
        const script = document.createElement("script");
        script.src = "https://checkout.razorpay.com/v1/checkout.js";
        script.async = true;
        document.body.appendChild(script);

        let param = {
            "amount": this.state.amount,
            "furl": fUrl+`&amount=${this.state.amount}`,
            "surl": sUrl+`&amount=${this.state.amount}`,
            "purl": pUrl+`&amount=${this.state.amount}`,
            "promo_code": this.state.mPromoCode,
            "deal_id": this.state.selectedDeal ? this.state.selectedDeal.deal_id : ""
        }
        this.setState({ isLoading: true })
        ls.set('back_history', this.props.history.length)
        depositRazorPayFund(param).then((responseJson) => {
            if (responseJson.response_code == WSC.successCode) {
                var pg_data = responseJson.data;
                var options = {
                    "key": pg_data.key,
                    "amount": pg_data.amount,
                    "name": pg_data.site_name,
                    "description": pg_data.amount,
                    "image": pg_data.image,
                    "order_id": pg_data.order_id,
                    "shopping_order_id": pg_data.merchant_order_id,
                    "callback_url": pg_data.action,
                    "redirect": true,
                    "handler": function (response) {
                        console.log(response);
                    },
                    "prefill": {
                        "name": pg_data.prefill.name,
                        "email": pg_data.prefill.email,
                        "contact": pg_data.prefill.contact
                    },
                    "theme": {
                        "color": "#15b8f3" // screen color
                    }
                };
                var propay = new window.Razorpay(options);
                propay.open();
            }
            setTimeout(() => {
                this.setState({ isLoading: false })
            }, 500);
        })
    }

    callOnlyAfterTransactions(contestData, FromConfirmPopupAddFunds, calledFrom,contestCoinData) {
        setTimeout(() => {

            if (parsed.status == "success") {

                if (FromConfirmPopupAddFunds == 'true') {
                    if (calledFrom == "SelectCaptainList" || calledFrom == "ContestListing" || calledFrom == "mycontest") {
                        if (SELECTED_GAMET == GameType.Tournament) {
                            this.gotoContestListingClass(contestData.FixturedContestItem, contestData.lobbyDataItem)
                        }
                        else {
                            this.CallJoinGameApi(contestData)
                        }
                    }
                    else if (calledFrom == "ContestJoinBuyCoins") {
                        this.callBuyCoinsApi(contestData, contestCoinData)
                    }
                    else {
                        this.gotoContestListingClass(contestData.FixturedContestItem, contestData.lobbyDataItem)
                    }
                }
                else if (calledFrom == 'BuyCoins') {
                    this.goToBuyCoinsScreen(contestData)
                }
                else {
                    let mHist = parseInt(ls.get('back_history') || 0);
                    let newHistory = this.props.history.length;
                    let updatedHistory = (newHistory - mHist) + 2;
                    this.props.history.go(-updatedHistory)
                }

            }
            else if (parsed.status == "failure" || parsed.status == "pending") {
                if (FromConfirmPopupAddFunds == 'true') {
                    if (calledFrom == "SelectCaptainList") {
                        if (SELECTED_GAMET == GameType.Tournament) {
                            this.gotoContestListingClass(contestData.FixturedContestItem, contestData.lobbyDataItem)
                        }
                        else {
                            WSManager.setFromConfirmPopupAddFunds(false)
                            this.props.history.replace({ pathname: '/' })
                        }
                    } else if (calledFrom == "mycontest") {
                        this.seeMyContest()
                    } else {

                        this.gotoContestListingClass(contestData.FixturedContestItem, contestData.lobbyDataItem)
                    }

                } else {
                    let mHist = parseInt(ls.get('back_history') || 0);
                    let newHistory = this.props.history.length;
                    let updatedHistory = (newHistory - mHist) + 2;
                    this.props.history.go(-updatedHistory)
                }
            }
        }, 1000)
    }

    CallJoinGameApi(dataFromConfirmPopUp) {
        let param = {
            "contest_id": dataFromConfirmPopUp.FixturedContestItem.contest_id,
            "lineup_master_id": dataFromConfirmPopUp.selectedTeam.lineup_master_id ? dataFromConfirmPopUp.selectedTeam.lineup_master_id : dataFromConfirmPopUp.selectedTeam.value.lineup_master_id,
            "promo_code": dataFromConfirmPopUp.promoCode,
        }
        this.setState({ isLoaderShow: true })
        let IsNetworkContest = dataFromConfirmPopUp.FixturedContestItem.is_network_contest && dataFromConfirmPopUp.FixturedContestItem.is_network_contest == 1 ;
        let apiCall = IsNetworkContest ? joinContestNetworkfantasy : joinContest;
        if(dataFromConfirmPopUp.lineUpMasterIdArray && dataFromConfirmPopUp.lineUpMasterIdArray.length > 1){
            apiCall = IsNetworkContest ? joinContestWithMultiTeamNF : joinContestWithMultiTeam;
            let resultLineup = dataFromConfirmPopUp.lineUpMasterIdArray.map(a => a.lineup_master_id);
            param['lineup_master_id'] = resultLineup
        }else{
            param['lineup_master_id'] = dataFromConfirmPopUp.selectedTeam.lineup_master_id ? dataFromConfirmPopUp.selectedTeam.lineup_master_id : dataFromConfirmPopUp.selectedTeam.value.lineup_master_id
        }

                apiCall(param).then((responseJson) => {
                if (responseJson.response_code == WSC.successCode) {
                    setTimeout(() => {
                        WSManager.googleTrack(WSC.GA_PROFILE_ID, 'contestjoin');
                        WSManager.googleTrackDaily(WSC.GA_PROFILE_ID, 'contestjoindaily');
                        WSManager.setFromConfirmPopupAddFunds(false);
                        WSManager.clearLineup();
                        Utilities.showToast(AppLabels.JOIN_SUCCESS_MESSAGE)
                        //this.ThankYouModalShow()
                        this.redirectToLobby()
                    }, 300);
                } else {
                    if (window.ReactNativeWebView && parsed.status == "success") {
                        setTimeout(() => {
                            WSManager.googleTrack(WSC.GA_PROFILE_ID, 'contestjoin');
                            WSManager.googleTrackDaily(WSC.GA_PROFILE_ID, 'contestjoindaily');
                            WSManager.setFromConfirmPopupAddFunds(false);
                            WSManager.clearLineup();
                            Utilities.showToast(AppLabels.JOIN_SUCCESS_MESSAGE)
                            //this.ThankYouModalShow()
                            this.redirectToLobby()
                        }, 300);
                    }
                    else{
                        var errorMsg = responseJson.message != '' ? responseJson.message : responseJson.global_error
    
                        if (errorMsg == '') {
                            for (var key in responseJson.error) {
                                errorMsg = responseJson.error[key];
                            }
                        }
                        if (responseJson.response_code == WSC.sessionExpireCode) {
                            this.logout();
                        }
                        Utilities.showToast(errorMsg, 3000);
                        setTimeout(() => {
                            let mHist = parseInt(ls.get('back_history') || 0);
                            let newHistory = this.props.history.length;
                            let updatedHistory = (newHistory - mHist) + 2;
                            this.props.history.go(-updatedHistory)
                        }, 500);
                    }
                       
                }
            })
        
    }

    redirectToLobby = () => {
        this.goToLobby()
    }

    gotoContestListingClass(data, lobbyItem) {
        if (SELECTED_GAMET == GameType.Tournament) {
            setTimeout(() => {
                let mHist = parseInt(ls.get('back_history') || 0);
                let newHistory = this.props.history.length;
                let updatedHistory = (newHistory - mHist) + 2;
                this.props.history.go(-updatedHistory)
            }, 500);
        }
        else {
            let dateformaturl = Utilities.getUtcToLocal(data.season_scheduled_date);
            dateformaturl = new Date(dateformaturl);

            let dateformaturlDate = ("0" + dateformaturl.getDate()).slice(-2)
            let dateformaturlMonth = ("0" + (dateformaturl.getMonth() + 1)).slice(-2)

            let home = data.home || lobbyItem.home;
            let away = data.away || lobbyItem.away;

            dateformaturl = dateformaturlDate + '-' + dateformaturlMonth + '-' + dateformaturl.getFullYear();
            let contestListingPath = Utilities.getSelectedSportsForUrl().toLowerCase() + '/contest-listing/' + data.collection_master_id + '/' + home + "-vs-" + away + "-" + dateformaturl + "?sgmty=" + btoa(SELECTED_GAMET)
            this.setState({ LobyyData: data });
            this.props.history.push({ pathname: contestListingPath.toLowerCase(), state: { FixturedContest: this.state.FixtureData, LobyyData: lobbyItem, isFromPM: true } })
        }
    }

    ThankYouModalShow = (data) => {
        this.setState({
            showThankYouModal: true,
        });
    }

    ThankYouModalHide = () => {
        this.setState({
            showThankYouModal: false,
        });
    }


    goToLobby = () => {
        let contestData = WSManager.getContestFromAddFundsAndJoin()
        let calledFrom = WSManager.getPaymentCalledFrom();
        setTimeout(() => {
            if (calledFrom == 'mycontest') {
                this.props.history.push({ pathname: '/' });
            } else {
                this.gotoContestListingClass(contestData.FixturedContestItem, contestData.lobbyDataItem)
            }
        }, 500);
    }

    seeMyContest = () => {
        this.props.history.push({ pathname: '/my-contests', state: { from: 'SelectCaptain' } });
    }

    hideStateTagModal = () => {
        this.setState({
            showStateTagModal: false,
        });
    }
    checkIfCashfreeExist = () => {
        var obj = Utilities.getMasterData().pg;
        if (Object.values(obj).indexOf('cashfree') > -1) {
            this.setState({checkIfCashfreeExist:true})
            this.getCashfreeDetails();
        }
    }

    getCashfreeDetails() {
        let param = {}
        this.setState({ isLoaderShow: true })
        getCashFreeGatewayList(param).then((responseJson) => {
            if (responseJson.response_code == WSC.successCode) {
                this.setState({
                    walletList: responseJson.data.wallet_list,
                    netBankingList: responseJson.data.bank_list
                })
                const wallet_list = [];
                const nb_list = [];
                const upi_list = [];


                responseJson.data.wallet_list && responseJson.data.wallet_list.map((data, key) => {
                    wallet_list.push({ value: data.payment_code, label: data.payment_option, type_code: data.type_code })
                    return '';
                })
                responseJson.data.bank_list && responseJson.data.bank_list.map((data, key) => {
                    nb_list.push({ value: data.payment_code, label: data.payment_option, type_code: data.type_code })
                    return '';
                })
                this.state.upiList && this.state.upiList.map((data, key) => {
                    upi_list.push({ value: data.upiMode, label: data.upiMode })
                    return '';
                })
                let sortedNbList = nb_list.sort((a, b) => a.label.localeCompare(b.label));
                this.setState({
                    walletDropDownList: wallet_list,
                    netBankingDropDownList: sortedNbList,
                    upiDropDownList: upi_list
                })
            } else {
                var errorMsg = responseJson.message != '' ? responseJson.message : responseJson.global_error

                if (errorMsg == '') {
                    for (var key in responseJson.error) {
                        errorMsg = responseJson.error[key];
                    }
                }
                if (responseJson.response_code == WSC.sessionExpireCode) {
                    this.logout();
                }
                Utilities.showToast(errorMsg, 3000);

            }
        })
    }
    chashfreeBanking = (item, e, type) => {
        e.stopPropagation()
        if (type == PAYMENT_TYPE.WALLET) {
            this.setState({ selectedWallet: item, selectedWalletOption: '' })
        }
        else if (type == PAYMENT_TYPE.NET_BANKING) {
            this.setState({ selectedNetBanking: item, selectedNBoption: '' })

        }
        this.handelPaymentType(type)
    }
    handleWalletChange = (selectedOption) => {
        this.setState({ selectedWalletOption: selectedOption }, () => {
            let selectWalletData = {}
            this.state.walletList && this.state.walletList.map((item, index) => {
                if (selectedOption.value == item.payment_code) {
                    selectWalletData = item;
                }
            })
            this.setState({ selectedWallet: selectWalletData })
        });
        this.handelPaymentType(PAYMENT_TYPE.WALLET)

    }
    handleNetBankingChange = (selectedOption) => {
        this.setState({ selectedNBoption: selectedOption }, () => {
            let selectNbData = {}
            this.state.netBankingList && this.state.netBankingList.map((item, index) => {
                if (selectedOption.value == item.payment_code) {
                    selectNbData = item;
                }
            })
            this.setState({ selectedNetBanking: selectNbData })
        });
        this.handelPaymentType(PAYMENT_TYPE.NET_BANKING)

    }
    handleUpiChange = (selectedOption) => {
        this.setState({ selectedUPIoption: selectedOption }, () => {
            let selectUPIData = {}
            this.state.upiList && this.state.upiList.map((item, index) => {
                if (selectedOption.value == item.upiMode) {
                    selectUPIData = item;
                }
            })
            this.setState({ selectedUPI: selectUPIData })
        });
        this.handelPaymentType(PAYMENT_TYPE.UPI)
    }

    handleChangeCardNumber = (e) => {
        this.setState({ cardNumber: e.target.value })

    }
    handleChangeName = (e) => {
        this.setState({ nameOnCard: e.target.value })
    }
    handleChangeExpiryDate = (e) => {
        this.setState({ expiryDate: e.target.value })
    }
    handleChangeCvv = (e) => {
        this.setState({ cvvNumber: e.target.value })
    }

    renderWalletView = () => {
        return (
            <div>
                <div onClick={() => this.onPaymentMethodSelect(Utilities.getMasterData().pg.wallet, PAYMENT_TYPE.WALLET)} className="item-view">
                    <div className={"btn-expand-action"}>
                        {/* <div className={"view-items"+ (this.state.paymentTypeSelected == PAYMENT_TYPE.WALLET ? ' active-border' : ' ')}>
                            <i className={"icon-plus" + (this.state.paymentTypeSelected == PAYMENT_TYPE.WALLET ? ' active' : ' not-active')}></i>
                        </div> */}
                        <div className={"title-payment" + (this.state.selectedWallet ? ' selected': '')  }>{AppLabels.PAYTM_WALLET}</div>

                    </div>
                    {/* <img src={Images.GROUP_WALLET} alt="" /> */}

                </div>
                {
                    (this.state.walletList && this.state.walletList.length > 0) &&
                    <div style={{ marginTop: 15 }}>
                     <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-evenly'}}>
 
                        {
                            this.state.walletList.map((item, index) => {
                                return (
                                    item.payment_code == "4007" || item.payment_code == "4009" || item.payment_code == "4001" ?
                                    <div onClick={(e) =>
                                        this.chashfreeBanking(item, e, PAYMENT_TYPE.WALLET)
                                    }
                                        className={"wallet-box" + (this.state.selectedWallet.payment_code == item.payment_code ? ' selected' : '')}>
                                        {/* <div className="title-wallet">{item.payment_option}</div> */}
                                        {
                                            item.payment_code == "4007" ?
                                                <img src={Images.PAYTM_IMG} alt="" />
                                                : item.payment_code == "4009" ?
                                                    <img style={{width:65}} src={Images.PHONE_PAY} alt="" />
                                                    : item.payment_code == "4001" ?
                                                        <img src={Images.FREECHARGE} alt="" />
                                                        : ''


                                        }
                                    </div>
                                    :''
                                )
                            })
                        }
                     </div>

                        <div className="verification-block mt-0 p-0 left-align no-margin-l no-margin-r">
                            <Row style={{ marginTop: 20 }}>
                                <Col style={{ zIndex: 100 }} xs={12}>
                                    <FormGroup className="input-label-center zIndex1000 input-transparent"
                                        controlId="formBasicText">
                                        {this.state.isCMounted && <Suspense fallback={<div />} ><ReactSelectDD
                                            className='select-field-transparent'
                                            classNamePrefix='select'
                                            id="select-country"
                                            arrowRenderer={this.arrowRenderer}
                                            onChange={this.handleWalletChange}
                                            options={this.state.walletDropDownList}
                                            value={this.state.selectedWalletOption}
                                            placeholder={'Select Other Wallet'}

                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 0,
                                                colors: {
                                                    ...theme.colors,
                                                    primary: '#013D79',
                                                },
                                            })}
                                        >
                                        </ReactSelectDD></Suspense>}
                                    </FormGroup>
                                </Col>
                            </Row>
                        </div>
                        {/* <div onClick={() => this.GoCashDeposit(PAYMENT_TYPE.WALLET)} className={"paynow-btn" +(this.state.selectedWallet != '' ? ' active-pay-now': ' disable-pay-now' )  }>
                            <div className="title-pay-now">{"PAY NOW!"}</div>
                        </div> */}

                    </div>


                }

            </div>
        )
    }

    renderNBView = () => {
        return (
            <div>
                <div onClick={() => this.onPaymentMethodSelect(Utilities.getMasterData().pg.net_banking, PAYMENT_TYPE.NET_BANKING)} className="item-view">
                    <div className={"btn-expand-action"}>
                    {/* <div className={"view-items"+ (this.state.paymentTypeSelected == PAYMENT_TYPE.NET_BANKING ? ' active-border' : ' ')}>
                            <i className={"icon-plus" + (this.state.paymentTypeSelected == PAYMENT_TYPE.NET_BANKING ? ' active' : ' not-active')}></i>
                        </div> */}
                        <div className={"title-payment" + (this.state.selectedNetBanking ? ' selected': '')  }>{AppLabels.NET_BANKING}</div>

                    </div>
                    {/* <img src={Images.NET_BANKING} alt="" /> */}

                </div>
                {
                    (this.state.netBankingList && this.state.netBankingList.length > 0) &&
                    <div style={{ marginTop: 15 }}>
                        <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-between', marginLeft: 5 }}>
                            {
                                this.state.netBankingList.slice(0,4).map((item, index) => {
                                    return (
                                        <>
                                            <div className="nb-view">
                                                <div onClick={(e) =>
                                                    this.chashfreeBanking(item, e, PAYMENT_TYPE.NET_BANKING)
                                                } className={"net-banking" + (this.state.selectedNetBanking.payment_code == item.payment_code ? ' selected' : '')}>
                                                    <img className="bank-logo" src={ Images.S3_BUCKET_IMG_PATH + item.bank_img } alt="" />
                                                </div>
                                                <div className="title-nb">
                                                    {item.bank_abbr}
                                                </div>
                                            </div>
                                        </>
                                    )
                                })
                            }
                        </div>
                        <div className="verification-block mt-0 p-0 left-align no-margin-l no-margin-r">
                            <Row style={{ marginTop: 20 }}>
                                <Col style={{ zIndex:101 }} xs={12}>
                                    <FormGroup className="input-label-center zIndex1000 input-transparent"
                                        controlId="formBasicText">
                                        {this.state.isCMounted && <Suspense fallback={<div />} ><ReactSelectDD
                                            className='select-field-transparent'
                                            classNamePrefix='select'
                                            id="select-country"
                                            arrowRenderer={this.arrowRenderer}
                                            onChange={this.handleNetBankingChange}
                                            options={this.state.netBankingDropDownList}
                                            value={this.state.selectedNBoption}
                                            placeholder={'Select From Other Bank'}

                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 0,
                                                colors: {
                                                    ...theme.colors,
                                                    primary: '#013D79',
                                                },
                                            })}
                                        >
                                        </ReactSelectDD></Suspense>}
                                    </FormGroup>
                                </Col>
                            </Row>
                        </div>
                        {/* <div onClick={() => this.GoCashDeposit(PAYMENT_TYPE.NET_BANKING)} className={"paynow-btn" +(this.state.selectedNetBanking != '' ? ' active-pay-now': ' disable-pay-now' )  }>
                            <div className="title-pay-now">{"PAY NOW!"}</div>

                        </div> */}

                    </div>


                }

            </div>
        )
    }

     renderUpiMode = () => {
        return (
            <div>
                <div onClick={() => this.onPaymentMethodSelect(Utilities.getMasterData().pg.upi, PAYMENT_TYPE.UPI)} className="item-view">
                    <div className={"btn-expand-action"}>
                    {/* <div className={"view-items"+ (this.state.paymentTypeSelected == PAYMENT_TYPE.UPI ? ' active-border' : ' ')}>
                            <i className={"icon-plus" + (this.state.paymentTypeSelected == PAYMENT_TYPE.UPI ? ' active' : ' not-active')}></i>
                        </div> */}
                        <div className={"title-payment" + (this.state.selectedUPI ? ' selected': '')  }>{AppLabels.UPI}</div>

                    </div>
                    {/* <img src={Images.UPI} alt="" /> */}

                </div>

                {
                    
                    <div>
                        <div className="verification-block mt-0 p-0 left-align no-margin-l no-margin-r">
                            <Row style={{ marginTop: 20 }}>
                                <Col style={{ zIndex: 99 }} xs={12}>
                                    <FormGroup className="input-label-center zIndex1000 input-transparent"
                                        controlId="formBasicText">
                                        {this.state.isCMounted && <Suspense fallback={<div />} ><ReactSelectDD
                                            className='select-field-transparent'
                                            classNamePrefix='select'
                                            id="select-country"
                                            arrowRenderer={this.arrowRenderer}
                                            onChange={this.handleUpiChange}
                                            options={this.state.upiDropDownList}
                                            value={this.state.selectedUPIoption}
                                            placeholder={'Select Upi'}

                                            theme={(theme) => ({
                                                ...theme,
                                                borderRadius: 0,
                                                colors: {
                                                    ...theme.colors,
                                                    primary: '#013D79',
                                                },
                                            })}
                                        >
                                        </ReactSelectDD></Suspense>}
                                    </FormGroup>
                                </Col>
                            </Row>
                        </div>
                        {/* <div onClick={() => this.GoCashDeposit(PAYMENT_TYPE.UPI)} className={"paynow-btn" +(this.state.selectedUPI != '' ? ' active-pay-now': ' disable-pay-now' )  }>
                            <div className="title-pay-now">{"PAY NOW!"}</div>

                        </div> */}
                    </div>
                }
            </div>
        )
    }

    render() {
        const HeaderOption = {
            back: true,
            title: AppLabels.SELECT_PAYMENT_METHOD,
            hideShadow: true
        }
        const { amount, PageContent, showThankYouModal, showStateTagModal, isCMounted } = this.state;
        return (
            <MyContext.Consumer>
                {(context) => (
                    <div className="web-container web-container-fixed trans-web-container">
                        <div className='hide'>{isCMounted && <Suspense fallback={<div/>}><ReactHTMLParser content={PageContent}/></Suspense>}</div>
                        {
                            this.state.isLoading && <CustomLoader />
                        }
                        <Helmet titleTemplate={`${MetaData.template} | %s`}>
                            <title>{MetaData.transactions.title}</title>
                            <meta name="description" content={MetaData.transactions.description} />
                            <meta name="keywords" content={MetaData.transactions.keywords}></meta>
                        </Helmet>
                        <CustomHeader {...this.props} HeaderOption={HeaderOption} />
                        <Row>
                            <Col sm={12}>
                                <div className="payable-amt">
                                    {AppLabels.TO_PAY} 
                                    <div>
                                     <i className="font-style-normal">{Utilities.getMasterData().currency_code}</i>
                                     <span>{amount}</span>
                                    </div>
                                    
                                </div>
                            </Col>
                        </Row>
                        <Row>
                            <Col sm={12}>
                                <div className={"payment-section-wrap"} >
                                    {Utilities.getMasterData().pg.upi &&
                                        <div className={"payment-selection" + (this.state.selectedUPI != '' ? ' payment-selection-border' :'') + (this.onMethodSelected(Utilities.getMasterData().pg.upi) ? ' cashfree-view-wallet height-expand'  : '')}>
                                            {
                                                this.onMethodSelected(Utilities.getMasterData().pg.upi)
                                                    ?
                                                    this.renderUpiMode()
                                                    :
                                                    <div onClick={() => this.onPaymentMethodSelect(Utilities.getMasterData().pg.upi, PAYMENT_TYPE.UPI)} >
                                                        {AppLabels.UPI}
                                                        <img src={Images.UPI} alt="" />
                                                    </div>

                                            }

                                        </div>
                                    }

                                    {Utilities.getMasterData().pg.wallet &&
                                        <div
                                            className={"payment-selection"+ (this.state.selectedWallet != '' ? ' payment-selection-border' :'') + (this.onMethodSelected(Utilities.getMasterData().pg.wallet) ? ' cashfree-view-wallet height-expand'   : '')}>
                                            {
                                                this.onMethodSelected(Utilities.getMasterData().pg.wallet)
                                                    ?
                                                    this.renderWalletView()
                                                    :
                                                    <div onClick={() => this.onPaymentMethodSelect(Utilities.getMasterData().pg.wallet, PAYMENT_TYPE.WALLET)} >
                                                        {AppLabels.PAYTM_WALLET}
                                                        <img src={Images.PAYTM_IMG} alt="" />
                                                    </div>

                                            }

                                        </div>
                                    }

                                    {Utilities.getMasterData().pg.credit_debit_card &&
                                        <div
                                            className={"payment-selection" + (this.onMethodSelected(Utilities.getMasterData().pg.credit_debit_card) ? (' cashfree-view-wallet' + (this.state.paymentTypeSelected == PAYMENT_TYPE.CREDIT_DEBIT_CARD ? ' height-expand' : '')) : '')}>

                                            {
                                                <div onClick={() => this.onPaymentMethodSelect(Utilities.getMasterData().pg.credit_debit_card, PAYMENT_TYPE.CREDIT_DEBIT_CARD)} >
                                                    {AppLabels.CREDIT_DEBIT_CARD}
                                                    <img src={Images.CREDIT_IMG} alt="" />
                                                </div>

                                            }
                                        </div>
                                    }

                                    {Utilities.getMasterData().pg.net_banking &&
                                        // <div onClick={() => this.onPaymentMethodSelect(Utilities.getMasterData().pg.net_banking, PAYMENT_TYPE.NET_BANKING)} className="payment-selection">
                                        //     {AppLabels.NET_BANKING}
                                        // </div>
                                        <div
                                            className={"payment-selection" +(this.state.selectedNetBanking != '' ? ' payment-selection-border' :'') + (this.onMethodSelected(Utilities.getMasterData().pg.net_banking) ? ' cashfree-view-wallet height-expand' : '')}>
                                            {
                                                this.onMethodSelected(Utilities.getMasterData().pg.net_banking)
                                                    ?
                                                    this.renderNBView()
                                                    :
                                                    <div onClick={() => this.onPaymentMethodSelect(Utilities.getMasterData().pg.net_banking, PAYMENT_TYPE.NET_BANKING)} >
                                                        {AppLabels.NET_BANKING}
                                                    </div>

                                            }

                                        </div>
                                    }

                                </div>
                            </Col>
                        </Row>
                        {showThankYouModal &&
                            <Thankyou ThankyouModalShow={this.ThankYouModalShow} ThankYouModalHide={this.ThankYouModalHide} goToLobbyClickEvent={this.goToLobby} seeMyContestEvent={this.seeMyContest} />
                        }
                        {
                            showStateTagModal &&
                            <EditStateAndCityModal
                                {...this.props}
                                mShow={showStateTagModal}
                                mHide={this.hideStateTagModal}
                            />
                        }

                       
                        {
                             this.state.checkIfCashfreeExist &&
                            <Button disabled={!this.state.paymentTypeSelected} onClick={() => this.GoCashDeposit(this.state.paymentTypeSelected)} className="btn-block btn-primary bottom">{"PAY NOW!"}</Button>
                        }
                    </div>
                )}
            </MyContext.Consumer>
        )
    }
}